<input
  #fileInput
  type="file"
  accept=".csv"
  style="display: none"
  [disabled]="disabled"
  (change)="onFileSelected($event)"
/>

<span
  class="select-file-tooltip-wrapper"
  [matTooltip]="tooltip"
  matTooltipPosition="above"
>
  <button
    class="btn-primary nowrap w-100 btn-import"
    type="button"
    [disabled]="disabled || (isLoading$ | async)"
    (click)="selectFile()"
  >
    <fa-icon icon="upload" [fixedWidth]="true"></fa-icon>
    {{ prompt }}
  </button>
</span>
